export function OnboardingDivisionService($http, apexApiUrl) {
    'ngInject'
    return {
        retrieveOnboardingDivisions: retrieveOnboardingDivisions
    };

    function retrieveOnboardingDivisions() {
        return $http({
            method: "GET",
            url: apexApiUrl + "onboarding-divisions",
            headers: { Accept: "application/json" }
        }).then(function (response) {
            return response.data;
        });
    }
}
